import { EventbriteServiceComponent } from './EventbriteServiceComponent';
export const EventbriteReconnectionConfig = {
  serviceComponent: EventbriteServiceComponent
};